module.exports = __webpack_public_path__ + "img/large arrow-icon.b7221367.svg";